// /notifications — единый центр уведомлений admin SPA (D18 — notifications hub).
//
// Backend endpoint: GET /api/admin/notifications (+ /{id}/read, /read-all,
// /unread-count). Permission на backend — `user.self.view` (есть у всех
// auth-users), поэтому frontend gating нет — достаточно `RequireAuth`.
// Entry-point — BellIcon в header'е (отдельный агент), в sidebar пункта нет.

import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { NotificationsScreen } from '../features/notifications/NotificationsScreen'

export const Route = createFileRoute('/notifications')({
  component: NotificationsRoute,
})

function NotificationsRoute() {
  return (
    <RequireAuth>
      <NotificationsScreen />
    </RequireAuth>
  )
}
